import axios from 'axios'

export default (autocompleteUrl, text) => {
  const url = `${autocompleteUrl}?text=${text}`

  return axios
    .get(url)
    .then(res => {
      const result = res.data
        .filter(location => location.Type === 'Ville')
        .map(location => {
          const key = Object.keys(location.Params)[0]

          const locationZip = location.Meta && location.Meta.Zips && location.Meta.Zips[0]

          return {
            label: location.Display,
            key: location.Params[key].toString(),
            value: {
              ...location,
              zipCodeValue: locationZip,
              toString() {
                return this.Display
              },
            },
          }
        })
      return result
    })
    .catch(e => e)
}
